/* esm.sh - @radix-ui/react-collapsible@1.1.12 */
export * from "/*@radix-ui/react-collapsible@1.1.12/esnext/react-collapsible.mjs";
